import React from 'react';
import { SessionRefresh, SessionRedirect, IsAuthenticated } from '@lendi/lala-react';
import { useFlags } from 'launchdarkly-react-client-sdk';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const { appointmentAuthExperiment } = useFlags();
  return (
    <div data-testid="ag">
      <SessionRefresh>
        <SessionRedirect
          returnURL={
            appointmentAuthExperiment
              ? `${window.location.protocol}//${window.location.host}/book-appointment/process`
              : window.location.href
          }
        >
          <IsAuthenticated>{children}</IsAuthenticated>
        </SessionRedirect>
      </SessionRefresh>
    </div>
  );
};
